import React, { Component } from 'react';
import HeaderImage from '../src/images/header.png';
import { Grid, Divider, Dropdown, Button, Menu, Image, Message, Popup, Label, Form, Input } from 'semantic-ui-react';
import AgencyInfo from './AgencyInfo';
import { Footer } from './layout/footer';
import 'semantic-ui-css/semantic.min.css';
import './index.css';
import config from './config.json';
import $ from 'jquery';
import sha256 from 'sha256';
import { any } from 'prop-types';

const Authentication =
{
    token: "",
    isValid: false
};

let options = [
    { key: '1', text: 'ConstructionHistory', value: 1 },
    { key: '2', text: 'OwnerLoadLimits', value: 2 },
    { key: '3', text: 'MinorStructures', value: 3 },
    { key: '4', text: 'ConstructionPlanning', value: 4 }
]

class AddUser extends Component {

    constructor(props) {
        super(props);
        this.finishedExit = false;
    }

    state = {
        visible: false,
        mode: "Gmaps",
        activeItem: 'AddUser',
        username: "",
        password: "",
        success: false,
        loginError: null,
        showLabel: false,
        shouldHideFooter: false,
        showPassword: false,
        isValidate: false,
        agencyId: 0,
        agencyName: '',
        email: '',
        primaryEmail: '',
        users: [],
        userCounter: 0,
    };

    addUser = () => {
        const users = [...this.state.users];
        let isAdd = true;

        if (this.state.userCounter < 4) {
            users.forEach(x => {
                if (!x.Email || !this.isValidEmail(x.Email)) {
                    isAdd = false;
                    alert("Before adding please ensure all existing user's email addresses are valid.");
                }
            });

            isAdd &&
                this.setState(prevState => ({
                    users: [
                        ...prevState.users,
                        { Id: 0, Email: "", Permissions: [] }
                    ],
                    userCounter: prevState.userCounter + 1,
                }));
        }
    }

    isValidEmail = (email) => {
        // Use a regular expression to validate the email format
        var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    }

    handleUserEmailChange = (event, index) => {
        const updatedUsers = [...this.state.users];
        updatedUsers[index].Email = event.target.value;
        this.setState({ users: updatedUsers });
    }

    handleUserPermissionChange = (value, index) => {
        const updatedUsers = [...this.state.users];
        updatedUsers[index].Permissions = value;
        this.setState({ users: updatedUsers });
    }

    removeUser = (index) => {
        if (this.state.userCounter > 0) {  // Ensure at least one user remains
            const updatedUsers = [...this.state.users];
            updatedUsers.splice(index, 1);
            this.setState(prevState => ({
                users: updatedUsers,
                userCounter: prevState.userCounter - 1,
            }));
        }
    }

    handleOnFocusToHideFooter = () => {
        if (window.mobileAndTabletcheck()) {
            this.setState({ shouldHideFooter: true });
        }
    }
    handleOnFocusToBringFooter = () => {
        if (window.mobileAndTabletcheck()) {
            this.setState({ shouldHideFooter: false });
        }
    }
    handleItemClick = (e, { name }) => this.setState({ activeItem: 'AddUser' })

    handleDismiss = () => {
        this.setState({ showLabel: false })
    }

    render() {

        const displayTabs = {
            "AddUser":
                <div>
                    <Divider hidden />

                    {!this.state.isValidate &&
                        <div>
                            <div className="pt-form-group pt-input-group pt-small" style={{ margin: 'auto', width: 200 }}>
                                <span className="pt-icon pt-icon-person"></span>
                                <input type="text" className="pt-input" value={this.state.username}
                                    onFocus={this.handleOnFocusToHideFooter}
                                    onBlur={this.handleOnFocusToBringFooter}
                                    onChange={({ target }) => {
                                        this.setState({ username: target.value });
                                    }}

                                    placeholder="Username" />
                            </div>
                            <Divider hidden />
                            <div className="pt-form-group pt-input-group pt-small" style={{ margin: 'auto', width: 200 }}>
                                <span className="pt-icon pt-icon-lock"></span>
                                <Popup

                                    trigger={<input type={`${this.state.showPassword ? 'text' : 'password'}`} className="pt-input"
                                        value={this.state.password}
                                        onFocus={this.handleOnFocusToHideFooter}
                                        onBlur={this.handleOnFocusToBringFooter}
                                        onChange={({ target }) => {
                                            this.setState({ password: target.value });
                                        }}

                                        placeholder="Password" />}
                                    header='Forgot Your Password?'
                                    content='Please, go back and click on Forget Password option'
                                    on='focus'
                                />
                                <span onClick={() => { this.setState({ showPassword: !this.state.showPassword }); }} className={`password-eye pt-icon ${this.state.showPassword ? 'pt-icon-eye-on' : 'pt-icon-eye-off'}`}></span>
                            </div>
                            <Divider hidden />
                            <div className="pt-form-group pt-small" style={{ margin: 'auto', marginTop: 5, width: 200 }}>
                                <Button primary disabled={!this.state.username || !this.state.password}
                                    onClick={this.onLogin} style={{ width: 180 }}>Next</Button>

                                <a onClick={() => window.open(sessionStorage.getItem('url') + '?activeItem=Editor', '_self')} style={{ textDecoration: 'underline', textAlign: 'center', paddingTop: 10 }}>Go Back</a>
                            </div>
                        </div>
                    }

                    {this.state.isValidate &&
                        <div>
                            <Grid style={{ maxHeight: 400, overflow: 'auto' }}>

                                <Grid.Row>
                                    <Grid.Column width={3}>
                                    </Grid.Column>
                                    <Grid.Column width={3}>
                                        <Label>
                                            Agency Name
                                        </Label>
                                    </Grid.Column>
                                    <Grid.Column width={4}>
                                        {this.state.agencyName}
                                    </Grid.Column>
                                    <Grid.Column width={6}>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column width={3}>
                                    </Grid.Column>
                                    <Grid.Column width={3}>
                                        <Label>
                                            Primary Email
                                        </Label>
                                    </Grid.Column>
                                    <Grid.Column width={4}>
                                        {this.state.primaryEmail}
                                    </Grid.Column>
                                    <Grid.Column width={6}>
                                        {this.state.users && this.state.users.length < 4 &&
                                            <Button primary size='mini'
                                                onClick={this.addUser} style={{ width: 80 }}>Add User</Button>
                                        }
                                    </Grid.Column>
                                </Grid.Row>

                                {
                                    this.state.users.map((user, index) => (
                                        <Grid.Row key={index}>
                                            <Grid.Column width={3}>
                                                <div style={{ float: 'right', paddingTop: 10 }}>
                                                    User Email {index + 2}
                                                </div>
                                            </Grid.Column>
                                            <Grid.Column width={3}>
                                                <input type="text" style={{ width: '-webkit-fill-available', height: 38 }} className="pt-input"
                                                    value={user.Email}
                                                    onChange={(event) => this.handleUserEmailChange(event, index)}
                                                    placeholder="Email" />
                                            </Grid.Column>
                                            <Grid.Column width={8}>
                                                <Dropdown placeholder='Add/ Edit Layer Permission' search fluid multiple selection
                                                    options={options}
                                                    value={user.Permissions}
                                                    onChange={(event, data) => this.handleUserPermissionChange(data.value, index)} />
                                            </Grid.Column>
                                            <Grid.Column width={2}>
                                                <div style={{ paddingTop: 8, fontSize: 18 }}>
                                                    <Popup
                                                        trigger={<span className="pt-icon pt-icon-help"></span>}
                                                        header='Permission Note'
                                                        content='Selected layer from the dropdown has add/edit permissions for the user'
                                                        on='focus'
                                                    />

                                                    <span style={{ paddingLeft: 15, color: 'red' }} className="pt-icon pt-icon-delete"
                                                        onClick={() => this.removeUser(index)}></span>
                                                </div>
                                            </Grid.Column>
                                        </Grid.Row>
                                    ))
                                }

                            </Grid>

                            <div className="pt-form-group pt-small" style={{ margin: 'auto', marginTop: 30, width: 160 }}>
                                <Button primary size='tiny'
                                    onClick={this.onSubmit} style={{ width: 140 }}>Submit</Button>

                                <a onClick={() => window.open(sessionStorage.getItem('url') + '?activeItem=Editor', '_self')} style={{ textDecoration: 'underline', textAlign: 'center', paddingTop: 15 }}>Go Back</a>
                            </div>
                            {/* Add warning banner to inform user about primry email changes  */}
                            <div style={{ margin: 'auto', marginTop: 60, width: 400 }}>
                                <Message warning style={{ margin: 'auto', width: 400 }}>
                                    <Message.Header>Note</Message.Header>
                                    <p>For any changes to the primary email, please feel free to contact us at <a href="mailto:grit@ugpti.org">grit@ugpti.org</a></p>
                                    

                                </Message>
                                </div>
                        </div>
                    }

                    <Divider hidden />

                    {this.state.showLabel && !this.state.success &&
                        <Message negative style={{ margin: 'auto', width: 400 }} onDismiss={this.handleDismiss}>
                            <Message.Header>Add User Failed!</Message.Header>
                            <p>{this.state.loginError}</p>
                        </Message>
                    }
                    {this.state.showLabel && this.state.success &&
                        <Message positive style={{ margin: 'auto', width: 400 }} onDismiss={this.handleDismiss}>
                            <Message.Header>Success</Message.Header>
                            <p>{this.state.loginError}</p>
                        </Message>
                    }

                </div>


        };

        // no if or switch statements :)
        let segValue = displayTabs[this.state.activeItem];

        return (
            <div className="loginHolder">
                <Grid stackable relaxed centered style={{ height: '100%', margin: 0 }} columns={1} >
                    <Grid.Column width={12}
                        style={{
                            backgroundColor: 'white',
                            border: '1px none #CCCCCC',
                            borderLeftStyle: 'solid',
                            borderRightStyle: 'solid',
                            position: 'relative',
                            margin: '0',
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: '100vh'
                        }}>

                        <Grid.Row >
                            {/* Header portion */}
                            <Image style={{ margin: 'auto' }} src={HeaderImage} />
                            <Divider hidden />

                            {/* page title */}
                            <Grid.Row>
                                <Grid.Column>
                                    <h2 style={{ textAlign: 'center' }}>Geographic Roadway Inventory Tool</h2>
                                </Grid.Column>
                            </Grid.Row>
                            <Divider hidden />

                            {/* Navigation */}
                            <Grid.Column width={4}>
                                <Menu pointing secondary style={{ border: '0px' }}>
                                    <Menu.Item name='Add User' active={this.state.activeItem === 'AddUser'} onClick={this.handleItemClick} />
                                </Menu>
                            </Grid.Column>

                            <Divider hidden />
                            <Grid.Row>
                                <Divider />
                            </Grid.Row>

                            {/* Content */}
                            <Grid.Row>
                                {segValue}
                            </Grid.Row>
                        </Grid.Row>
                        <Divider hidden />

                        {/*Insert footer component*/}
                        <Footer />
                    </Grid.Column>
                </Grid>
            </div>
        );
    }

    switchMode = ({ target }) => {
        this.setState({ mode: target.value });
        console.log(target.value);
    }

    async componentDidMount() {

        if (!this.finishedExit) {
            this.setState({ visible: true });
        }

        const { search } = this.props.location;

        if (search === "?activeItem=Help") {
            this.setState({ activeItem: "Help" });
        } else if (search === "?activeItem=Editor") {
            this.setState({ activeItem: "Editor" });
        }
    }


    onLogin = (e) => {
        this.setState({ visible: false });
        this.finishedExit = true;

        console.log("login called");
        this.validateReset(e);
    }

    onSubmit = (e) => {
        this.setState({ visible: false });
        this.finishedExit = true;

        console.log("submit called");

        $.ajax({
            type: 'POST',
            url: `${config.server}/adduser/permission`,
            data: {
                AgencyId: this.state.agencyId,
                AgencyName: this.state.agencyName,
                PrimaryEmail: this.state.primaryEmail,
                Users: this.state.users
            }
        })
            .done((data) => {
                console.log(data['Message']);
                if (data['Message'] === "valid") {
                    this.setState({ showLabel: true })
                    this.setState({ success: true });
                    this.setState({
                        loginError: "Users added/ updated successfully.",
                        isValidate: true
                    });

                }
                else {
                    this.setState({ showLabel: true })
                    this.setState({ success: false });
                    this.setState({
                        loginError: data['Description'] || "Failed to add users",
                        isValidate: true
                    });
                }
            })
            .fail((jqXhr) => {
                console.log('failed to connect to server');
                console.log(jqXhr);
            });

        e.preventDefault();

    }

    exitCallback = () => {
        if (this.finishedExit) {
            if (this.state.mode === "Gmaps") {
                this.props.history.push('/maing');
            }
            else if (this.state.mode === "Leaflet") {
                this.props.history.push('/mainl');
            }
            else if (this.state.mode === "Wrld") {
                this.props.history.push('/mainw');
            }
        }
    }

    exitCallbackRoute = (reroute = null) => {
        if (reroute) {
            this.props.history.push("/" + reroute);
        }
        else {
            this.props.history.push('/maing');
        }
    }

    componentDidUpdate() {

    }

    validateReset = (e) => {

        const passHash = sha256(this.state.password).toString('hex');

        $.ajax({
            type: 'POST',
            url: `${config.server}/adduser/authenticate`,
            data: {
                UserNameID: this.state.username,
                Password: passHash, //hasha(this.state.password)
            }// + salt = 'grit1234'
        })
            .done((data) => {
                console.log(data['Message']);
                if (data['Message'] === "valid") {
                    this.setState({ showLabel: false })
                    this.setState({ success: true });
                    data.PrimaryPermission.forEach(z => {
                        switch (z) {
                            case 'Signs':
                                options.push({ key: '6', text: 'Signs', value: 6 });
                                break;
                            case 'VRIC':
                                options.push({ key: '5', text: 'VRIC', value: 5 });
                                break;
                            default:
                                break;
                        }

                    });

                    this.setState({
                        loginError: "Validate successfully.",
                        username: "",
                        password: "",
                        isValidate: true,
                        agencyId: data.AgencyId,
                        agencyName: data.Name,
                        email: data.Email,
                        primaryEmail: data.PrimaryEmail,
                        users: data.Users || [],
                        userCounter: data.Users && data.Users.length || 0
                    });

                }
                else {
                    this.setState({ showLabel: true })
                    this.setState({ success: false });
                    this.setState({
                        loginError: data['Description'] || "Incorrect username or password",
                        username: "",
                        password: "",
                        isValidate: false,
                        agencyId: 0,
                        agencyName: '',
                        email: '',
                        primaryEmail: '',
                        users: [],
                        userCounter: 0
                    });
                }
            })
            .fail((jqXhr) => {
                console.log('failed to connect to server');
                console.log(jqXhr);
            });

        e.preventDefault();
    }

}

export default AddUser;


// WEBPACK FOOTER //
// ./src/adduser.js